import { useState } from "react";
import EnquiryForm from "./EnquiryForm";
import SmallEnquiryForm from "./SmallEnquiryForm";
import { RxCross2 } from "react-icons/rx";

const EnquiryModal = ({
  setEnquiryModal,
  smallEnquiryForm = false,
  enquirySource,
}) => {
  const [isOpen, setIsOpen] = useState(true);

  const handleClose = (e) => {
    if (e.target.id === "overlay") {
      setIsOpen(false);
      setEnquiryModal(false);
    }
  };

  return (
    <>
      {isOpen && (
        <div
          id="overlay"
          className="fixed inset-0 flex items-center justify-center bg-opacity-50 z-[1000]"
          style={{ background: "rgba(0, 0, 0, 0.2)" }}
          onClick={handleClose}
        >
          <div
            className="lg:w-[40vw] w-[90%] relative sm:w-[80%] rounded-lg scrollbar-hidden overflow-y-scroll"
            style={{
              height: smallEnquiryForm
                ? "h-fit"
                : window.innerWidth < 1100
                ? window.innerWidth < 450
                  ? "85vh"
                  : "80vh"
                : "90vh",
            }}
          >
            <RxCross2
              onClick={() => {
                setIsOpen(false);
                setEnquiryModal(false);
              }}
              className="absolute w-7 h-7 cursor-pointer text-[#d31c4f] top-[2.4%] sm:top-[5%] right-[5%] "
            />
            {!smallEnquiryForm ? (
              <EnquiryForm
                enquirySource={enquirySource}
                width={"100%"}
                paddingX={"5%"}
              />
            ) : (
              <SmallEnquiryForm
                enquirySource={enquirySource}
              ></SmallEnquiryForm>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default EnquiryModal;
